import { IMenuItem } from '../app/shared/components/menu/menu-item.interface';

export const SiteMenu: IMenuItem[] = [
    {
        i18nKey: 'siteMenu.home',
        routerLink: '/dashboard',
        matIcon: 'home',
    },
    {
        i18nKey: 'siteMenu.ship.groupName',
        matIcon: 'local_shipping',
        children: [
            {
                i18nKey: 'siteMenu.ship.shipUps',
                routerLink: '/ship/ups',
            },
            {
                i18nKey: 'siteMenu.ship.shipFedEx',
                routerLink: '/ship/fedex',
            },
            {
                i18nKey: 'siteMenu.ship.worldShipUpload',
                routerLink: '/world-ship-upload',
            },
        ],
    },
    {
        i18nKey: 'siteMenu.track.groupName',
        matIcon: 'track_changes',
        children: [
            {
                i18nKey: 'siteMenu.track.recentShipments',
                routerLink: '/recent-shipment',
            },
            {
                i18nKey: 'siteMenu.track.shipmentHistory',
                routerLink: '/shipment-history',
            },
            {
                i18nKey: 'siteMenu.track.reportHistory',
                routerLink: '/report-history',
            },
            {
                i18nKey: 'siteMenu.track.scheduledPickups',
                routerLink: '/schedule-pickups',
            },
            {
                i18nKey: 'siteMenu.track.savedQuotes',
                routerLink: '/saved-quotes',
            },
            {
                i18nKey: 'siteMenu.track.endOfDayReports',
                routerLink: '/reports/end-of-day-reports',
            },
            {
                i18nKey: 'siteMenu.track.trackShipments',
                routerLink: '/track-shipments',
            },
            {
                i18nKey: 'siteMenu.track.claims',
                routerLink: '/claims',
            },
            {
                i18nKey: 'siteMenu.track.claimDashboard',
                routerLink: '/claims/dashboard',
            }, {
                i18nKey: 'siteMenu.track.fileClaim',
                routerLink: '/claims/file-claim',
            }, {
                i18nKey: 'siteMenu.track.claimMessageCenter',
                routerLink: '/claims/message-center',
            }, {
                i18nKey: 'siteMenu.track.claimFaq',
                routerLink: '/claims/faq',
            },
        ],
    },
    {
        i18nKey: 'siteMenu.eCommerce.groupName',
        matIcon: 'package_2',
        children: [
            {
                i18nKey: 'siteMenu.eCommerce.orderManagement',
                routerLink: '/e-commerce/order-management',
            },
            {
                i18nKey: 'siteMenu.eCommerce.settings',
                routerLink: '/e-commerce/settings',
            },
            {
                i18nKey: 'siteMenu.eCommerce.faq',
                routerLink: '/e-commerce/faq',
            },
        ],
    },
    {
        i18nKey: 'siteMenu.billing.groupName',
        matIcon: 'receipt',
        children: [
            {
                i18nKey: 'siteMenu.billing.billingHistory',
                routerLink: '/billing-history',
            },
            {
                i18nKey: 'siteMenu.billing.claims',
                routerLink: '/claims',
            },
            {
                i18nKey: 'siteMenu.billing.paymentHistory',
                routerLink: '/payment-history',
            },
            {
                i18nKey: 'siteMenu.billing.manageCreditCards',
                routerLink: '/manage-credit-card',
            },
            {
                i18nKey: 'siteMenu.billing.creditHistory',
                routerLink: '/credit-history',
            },
        ],
    },
    {
        i18nKey: 'siteMenu.addressBook.groupName',
        matIcon: 'contacts',
        children: [
            {
                i18nKey: 'siteMenu.addressBook.addressBook',
                routerLink: '/address-book',
            },
            {
                i18nKey: 'siteMenu.addressBook.manageShipFromLocations',
                routerLink: '/manage-locations',
            },
        ],
    },
    {
        i18nKey: 'siteMenu.account.groupName',
        matIcon: 'account_box',
        children: [
            {
                i18nKey: 'siteMenu.account.userSettings',
                routerLink: '/user-settings',
            },
            {
                i18nKey: 'siteMenu.account.companyProfile',
                routerLink: '/company-profile',
            },
            {
                i18nKey: 'siteMenu.account.manageUsers',
                routerLink: '/manage-users',
            },
            {
                i18nKey: 'siteMenu.account.rewardShip',
                routerLink: '/rewardship',
            },
            {
                i18nKey: 'siteMenu.account.dwRewardShip',
                routerLink: '/dw-rewardship',
            },
            {
                i18nKey: 'siteMenu.account.manageNotifyTemplates',
                routerLink: '/notify-templates',
            },
        ],
    },
    {
        i18nKey: 'siteMenu.support.groupName',
        matIcon: 'help_outline',
        children: [
            {
                i18nKey: 'siteMenu.support.orderSupplies',
                routerLink: '/support/supply-or.der',
            },
            {
                i18nKey: 'siteMenu.support.contactUs',
                routerLink: '/support/contact-us',
            },
        ],
    },
    {
        i18nKey: 'siteMenu.logout',
        routerLink: '/logout',
        matIcon: 'power_settings_new',
    },
];

